import {
  useDatasetMetadataKeys,
  useDatasetTags,
} from "@/shared/domain/datasets/hooks";
import {
  useEventMetadataKeys,
  useEventNames,
  useEventTags,
} from "@/shared/domain/events/hooks";
import {
  useFileMetadataKeys,
  useOrgFileTags,
} from "@/shared/domain/files/hooks";
import { useAllTopicKeys } from "@/shared/domain/topics/hooks";

import { QueryTarget } from "../QueryRecord";
import { type RoboqlExternalCtx } from "../RoboqlExternalCtx";

export const useRoboqlExternalCtx = (
  target: QueryTarget,
  orgId: string,
): RoboqlExternalCtx => {
  const fileTagsQuery = useOrgFileTags(orgId);
  const fileMetadataKeysQuery = useFileMetadataKeys(orgId);
  const datasetTagsQuery = useDatasetTags(orgId);
  const datasetMetadataKeysQuery = useDatasetMetadataKeys(orgId);
  const allTopicKeysQuery = useAllTopicKeys(orgId);
  const eventNamesQuery = useEventNames(orgId);
  const eventTagsQuery = useEventTags(orgId);
  const eventMetadataKeysQuery = useEventMetadataKeys(orgId);

  return {
    target,
    datasets: {
      tags: datasetTagsQuery,
      metadataKeys: datasetMetadataKeysQuery,
    },
    files: {
      tags: fileTagsQuery,
      metadataKeys: fileMetadataKeysQuery,
    },
    topics: allTopicKeysQuery,
    events: {
      names: eventNamesQuery,
      tags: eventTagsQuery,
      metadataKeys: eventMetadataKeysQuery,
    },
  };
};
